

const SelectInput = ({ label,id,options,onValueChange }:any) => {
    return (
        <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
            {' '}
            <div className="input-container ">
                <div className="label"> {label} </div>
                <select className="custom" defaultValue={''}
                    onChange={(e) => onValueChange(id,e.target.value)}
                >
                    {
                        options.map((option:any,i:any) => {
                            return (
                                <option key={i} value={option.value}>
                                    {option.label}
                                </option>
                            );
                        })
                    }
                 
                </select>
            </div>
        </div>
    );
}

export default SelectInput;